export function descricaoProduto (produto) {
  var descricao = ''
  if (produto.descricao_ecommerce) {
    descricao = produto.descricao_ecommerce.replace(/<.*?>/g, '')
  } else {
    if (produto.descricao) {
      descricao = produto.descricao.replace(/<.*?>/g, '')
    }
  }
  const um = produto.um_erp ? produto.um_erp : ''
  return `${descricao} - ${um}`
}
